import { render, staticRenderFns } from "./Explanation9.vue?vue&type=template&id=65e70080&scoped=true&lang=pug&"
import script from "./Explanation9.vue?vue&type=script&lang=ts&"
export * from "./Explanation9.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e70080",
  null
  
)

export default component.exports